import React, { useState } from 'react';
import styled from 'styled-components';
import { useIntl, FormattedMessage } from 'react-intl';
import { observer } from 'mobx-react-lite';
import PropTypes from 'prop-types';

import {
    Sizes,
    AlternateButton,
    Locales,

    MAGIC_LINK_VARIANTS,
    useSession,
    SignInModal,
} from '@ratehub/base-ui';


function HeaderUserAccountMenuLogin({
    requiresLogin,
    magicLinkVariant,
    resumeApplicationLink,
    documentOptions,
    modalOpen,
    ...otherProps
}) {
    const intl = useIntl();
    const sessionStore = useSession();

    const [ modalIsOpen, setModalIsOpen ] = useState(false);

    function handleOpenModal() {
        setModalIsOpen(true);
    }

    function handleCloseModal() {
        setModalIsOpen(false);

        if (requiresLogin) {
            document.location.href = '/';
        }
    }

    return (
        <>
            <SignInModal
                isOpen={modalIsOpen || modalOpen}
                onClose={handleCloseModal}
                magicLinkVariant={magicLinkVariant}
                resumeApplicationLink={resumeApplicationLink}
                documentOptions={documentOptions}
            />

            <SignInButton
                intl={intl}
                onClick={() => sessionStore.hasFetchedSession && handleOpenModal()}
                size="small"
                type="button"
                data-name="sign-in"
                {...otherProps}
            >
                <FormattedMessage
                    id="web-server.header.sign-in-button-label"
                    defaultMessage="Sign in"
                />
            </SignInButton>
        </>
    );
}

HeaderUserAccountMenuLogin.propTypes = {
    requiresLogin: PropTypes.bool.isRequired,
    magicLinkVariant: PropTypes.oneOf(Object.values(MAGIC_LINK_VARIANTS)),
    resumeApplicationLink: PropTypes.string,
    documentOptions: PropTypes.shape({
        document: PropTypes.object,
        documentType: PropTypes.string,
        documentToken: PropTypes.string,
        documentRedirect: PropTypes.string,
    }),
    modalOpen: PropTypes.bool.isRequired,
};

const SignInButton = styled(AlternateButton)`
    ${props => props.intl.locale === Locales.ENGLISH && `
        text-transform: capitalize;
    `}

    font-size: ${Sizes.FONTS['2XS']};

    white-space: nowrap;
    min-width: ${Sizes.SPACING.FOUR};
`;

export default observer(HeaderUserAccountMenuLogin);
